import Helper from "@ember/component/helper"
import _ from "lodash"

export function kbLinkId(params) {
  let title = _.kebabCase(params[0])
  let id = params[1]
  return `${title}-${id}`
}

export default class KbLinkId extends Helper {
  compute = kbLinkId
}
